import React from "react";
import Table from "../../../components/Table";
import { TableRow } from "@material-ui/core";
import { IconButton, TableCell, Tooltip } from "@mui/material";
import VisibilityIcon from "@material-ui/icons/Visibility";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { useIntl } from "react-intl";
import { ROUTE_PATHS } from "../../../utils/PathsNames";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import PropTypes from "prop-types";

function FlashCardList({ setDeleteModal = () => {}, list = [] }) {
  const { messages } = useIntl();
  const history = useHistory();
  const {
    shared: { viewLabel, editLabel, deleteLabel }
  } = messages;

  const handleView = (id) => {
    history.push(`${ROUTE_PATHS.flashcardQuestions}/View/${id}`);
  };

  const handleEdit = (id) => {
    history.push(`${ROUTE_PATHS.flashcardQuestions}/Edit/${id}`);
  };
  const handleDelete = (id) => {
    setDeleteModal({ id, open: true });
  };
  return (
    <Table
      headlines={["Question Code", "System Name", "Subject name"]}
      hasActions={true}
      rows={
        Array.isArray(list) && list.length > 0
          ? list?.map((row) => (
              <TableRow className="table__row" key={row.id}>
                <TableCell
                  className="table__cell table__actions"
                  align=""
                >
                  {row?.question_code?.length > 15
                    ? `${row?.question_code?.slice(0, 9)}...`
                    : row?.question_code}
                </TableCell>
                <TableCell
                  className="table__cell table__actions"
                  align=""
                >
                  {row?.topic_name}
                </TableCell>
                <TableCell
                  className="table__cell table__actions"
                  align=""
                >
                  {row?.sub_topic_name}
                </TableCell>
                <TableCell
                  className="table__cell table__actions"
                  align="right"
                >
                  <Tooltip title={viewLabel}>
                    <span>
                      <IconButton
                        onClick={() => handleView(row.id)}
                        aria-label="view"
                      >
                        <VisibilityIcon
                          className="table__view"
                          fontSize="medium"
                        />
                      </IconButton>
                    </span>
                  </Tooltip>
                  <Tooltip title={editLabel}>
                    <span>
                      <IconButton
                        onClick={() => handleEdit(row.id)}
                        aria-label="edit"
                      >
                        <EditIcon
                          className="table__edit"
                          fontSize="medium"
                        />
                      </IconButton>
                    </span>
                  </Tooltip>

                  <Tooltip title={deleteLabel}>
                    <span>
                      <IconButton
                        onClick={() => handleDelete(row.id)}
                        aria-label="delete"
                        className="text-gray"
                      >
                        <DeleteIcon
                          className={`table__delete`}
                          fontSize="medium"
                        />
                      </IconButton>
                    </span>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))
          : []
      }
    />
  );
}

FlashCardList.propTypes = {
  list: PropTypes.array.isRequired,
  setDeleteModal: PropTypes.func.isRequired
};

export default FlashCardList;
